import { isClientFailureNotAuthorized } from '@art-suite/art-core-ts';
import { useEffect } from 'react';
import { useAuth } from '../useAuth';
import { useKaiProApiClient } from '../useKaiProApiClient';
import { useClearCache } from './useClearCache';

export const useAutoSwitchOrgForResource = ({
  error,
  propertyProjectId,
  scanId,
  orgPropertyId,
  orgMarketId,
  scanTemplateId,
  orgContractorId,
}: {
  error: any;
  propertyProjectId?: string;
  scanId?: string;
  orgPropertyId?: string;
  orgMarketId?: string;
  scanTemplateId?: string;
  orgContractorId?: string;
}) => {
  const { credentialsMutators } = useAuth();
  const clearCache = useClearCache();

  const kaiProApiClient = useKaiProApiClient();

  useEffect(() => {
    if (error && isClientFailureNotAuthorized(error.status)) {
      kaiProApiClient.getOrgIdForResource({ propertyProjectId, scanId, orgPropertyId, orgMarketId, scanTemplateId, orgContractorId }).then(
        async ({ orgId }) => {
          await credentialsMutators.switchOrg(orgId);
          await clearCache();
          // reload page
          window.location.reload();
        },
      );
    }
  }, [error]);
};
